import { action, computed } from 'mobx';

import { AppManager, Variables } from 'core/index';

import { PaymentSpaceModel, PaymentSpaceApp } from 'apps/payment/app';

import {
  ProfileInvoicesQuery,
  InitiativeInvoicesQuery,
} from 'apps/payment/gql';

export class PaymentHistoryManager extends AppManager {
  constructor(parent, init = {}) {
    super(parent, init);
    this.AppRef('paymentSpace', PaymentSpaceApp);

    this.variables = new Variables({
      spaceSlug: () => this.spaceSlug,
    });
    this.variables.onChange(['spaceSlug'], this.NewPaymentHistoryQuery);
  }

  @computed get loading() {
    const invoicesQuery = this.queries.get('invoices');
    return invoicesQuery ? invoicesQuery.loading : true;
  }

  @action NewPaymentHistoryQuery = () => {
    if (!this.variables.spaceSlug) return;
    let InvoicesQuery = null;
    if (this.variables.spaceSlug[0] === '+') {
      InvoicesQuery = InitiativeInvoicesQuery;
    } else if (this.variables.spaceSlug[0] === '@') {
      InvoicesQuery = ProfileInvoicesQuery;
    }

    if (!InvoicesQuery) return;
    const q = new InvoicesQuery(this, { queryKey: 'invoices' });
    q.process(
      result => (result ? PaymentSpaceModel.Load(result) : null),
      this.UpdatePaymentSpace,
    );
    q.query();
  };

  @action UpdatePaymentSpace = paymentSpaceModel => {
    this.paymentSpace = paymentSpaceModel;
  };
}
